import { useColorScheme } from "react-native"
import { DEFAULT_DISPLAY_MODE, DisplayMode } from "../../lib/display-mode"

export const useSystemDisplayMode = (): DisplayMode =>
  useColorScheme() || DEFAULT_DISPLAY_MODE
